import React from "react";
import "./styles/IocView.css";

const IocFilters = ({
  filters,
  handleChange,
  resetFilters,
  searchQuery,
  handleSearch,
  handleCollapseReset,
  onAddIoc,
  totalCount,
  totalAll
}) => {
  return (
    <div className="filter-container ioc-wrapper mb-4">
      {/* 🔹 HEADER TOUT À DROITE */}
      <div className="d-flex justify-content-end align-items-center flex-wrap gap-2 mb-3">
        {/* Count */}
        {typeof totalCount !== "undefined" && (
          <span className="filter-title-iocs" id="iocCount">
            {totalCount} of {totalAll} IoCs
          </span>
        )}

        {/* Search bar */}
        <form onSubmit={(e) => e.preventDefault()} className="d-flex">
          <div className="input-group" style={{ minWidth: "280px" }}>
            <input
              id="searchQueryIocs"
              type="text"
              name="searchQuery"
              value={searchQuery}
              onChange={handleSearch}
              className="form-control"
              placeholder="Search an IoC, Tag..."
              autoComplete="off"
            />
          </div>
        </form>

        {/* Add IoC */}
        <button className="btn btn-add-ioc" onClick={onAddIoc}>
          <i className="bi bi-bug"></i> Add IoC
        </button>

        {/* Reset buttons */}
        <button
          id="reset-filters-iocs"
          onClick={resetFilters}
          className="btn btn-reset"
          title="Reset filters"
        >
          <i className="bi bi-arrow-clockwise"></i>
        </button>

        {handleCollapseReset && (
          <button
            id="reset-collapses-iocs"
            onClick={handleCollapseReset}
            className="btn btn-collapse-reset"
            title="Reset collapses"
          >
            <i className="bi bi-x-square"></i>
          </button>
        )}
      </div>

      {/* 🔸 FILTERS GRID */}
      <div className="filter-grid-iocs">
        <div className="filter-item-date">
          <select
            id="filterTimeRangeIoc"
            name="time_range"
            className="form-select"
            value={filters.time_range}
            onChange={handleChange}
          >
            <option value="">All Time</option>
            <option value="1">Last 24 Hours</option>
            <option value="7">Last 7 Days</option>
            <option value="30">Last 30 Days</option>
            <option value="90">Last 90 Days</option>
          </select>
        </div>

        <div className="filter-item-date">
          <select
            id="filterTypeIoc"
            name="iocType"
            className="form-select"
            value={filters.iocType}
            onChange={handleChange}
          >
            <option value="">Types</option>
            <option value="Domain">Domain</option>
            <option value="Email">Email</option>
            <option value="IP">IP</option>
            <option value="Hash">Hash</option>
            <option value="Url">URL</option>
            <option value="Phone">Phone</option>
          </select>
        </div>

        <div className="filter-item-date">
          <select
            id="filterStatusIoc"
            name="status"
            className="form-select"
            value={filters.status}
            onChange={handleChange}
          >
            <option value="">Status</option>
            <option value="pending">Pending</option>
            <option value="acknowledged">Acknowledged</option>
            <option value="ongoing">Ongoing</option>
            <option value="closed">Closed</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>

        <div className="filter-item-date">
          <select
            id="filterCriticalityIoc"
            name="criticality"
            className="form-select"
            value={filters.criticality}
            onChange={handleChange}
          >
            <option value="">Criticality</option>
            <option value="1">Low</option>
            <option value="2">Medium</option>
            <option value="3">High</option>
            <option value="4">Critical</option>
            <option value="5">Severe</option>
          </select>
        </div>

        <div className="filter-item-date">
          <select
            id="filterAffectedCountryIoc"
            name="affected_country"
            className="form-select"
            value={filters.affected_country}
            onChange={handleChange}
          >
            <option value="">Affected Country</option>
            <option value="BE">Belgium</option>
            <option value="DE">Germany</option>
            <option value="FR">France</option>
            <option value="CH">Switzerland</option>
            <option value="US">United States</option>
            <option value="IT">Italy</option>
            <option value="IE">Ireland</option>
            <option value="ES">Spain</option>
            <option value="GR">Greece</option>
            <option value="Unknown">World</option>
          </select>
        </div>

        <div className="filter-item">
          <div className="form-check m-0 d-flex align-items-center">
            <input
              className="form-check-input"
              type="checkbox"
              name="related_to_incident"
              checked={filters.related_to_incident}
              onChange={handleChange}
              id="filterRelatedIncident"
            />
            <label
              className="form-check-label ms-2"
              htmlFor="filterRelatedIncident"
              style={{ color: "#9a9a9a", fontWeight: "bold", marginTop: "4px" }}
            >
              Related to Incident
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IocFilters;
